// @flow
import debounce from 'lodash-es/debounce';

import { sendEvent, payloadCreator, getPage } from '../utils/analytics';
import type { SyncType } from '../typings/product';

const category = 'Stock-2';
const payload = payloadCreator(category);

const change = (action: string, mass: boolean): Promise<void> =>
  sendEvent(payload(mass ? 'massChange' : 'change', action));

export default {
  checkAll: (state: boolean): Promise<void> =>
    sendEvent(payload('checkAll', String(state))),
  check: (state: boolean): Promise<void> =>
    sendEvent(payload('check', String(state))),
  change,
  debouncedChange: (debounce(change, 1000): any),
  toggleVariations: (state: boolean): Promise<void> =>
    sendEvent(payload('toggleVariations', String(state))),
  loadMore: (): Promise<void> =>
    sendEvent(payload('loadMore', '', Number(getPage()) - 1)),
  openLightbox: (id: string): Promise<void> =>
    sendEvent(payload('openLightbox', id)),
  lightboxYes: (id: string): Promise<void> =>
    sendEvent(payload('lightboxYes', id)),
  lightboxNo: (id: string): Promise<void> =>
    sendEvent(payload('lightboxNo', id)),
  closeLightbox: (id: string): Promise<void> =>
    sendEvent(payload('closeLightbox', id)),
  importAction: (): Promise<void> => sendEvent(payload('import')),
  startReimport: (sitesIds: string): Promise<void> =>
    sendEvent(payload('startReimport', sitesIds)),
  confirmAutoImport: (autoPublish: boolean): Promise<void> =>
    sendEvent(
      payload(
        'confirmAutoImport',
        autoPublish ? 'autoPublish' : 'noAutoPublish'
      )
    ),
  excelAction: (): Promise<void> => sendEvent(payload('excel')),
  addAction: (): Promise<void> => sendEvent(payload('add')),
  productsSync: (syncType: SyncType): Promise<void> =>
    sendEvent(
      payload(syncType === 'quantities' ? 'syncQuantities' : 'syncContent')
    ),
  submitTurnOnSite: (label: string, value: number): Promise<void> =>
    sendEvent(payload('submitTurnOnSite', `${label}Items`, value)),
  applyChanges: (): Promise<void> => sendEvent(payload('applyChanges')),
  cancelChanges: (): Promise<void> => sendEvent(payload('cancelChanges')),
  createSimilar: (): Promise<void> => sendEvent(payload('createSimilar')),
  confirmUnarchiveAndList: (): Promise<void> =>
    sendEvent(payload('confirmUnarchiveAndList')),
  cancelUnarchiveAndList: (): Promise<void> =>
    sendEvent(payload('cancelUnarchiveAndList')),
  showFreeAuPopup: (): Promise<void> => sendEvent(payload('showFreeAuPopup')),
  listFreeOnAu: (count: number): Promise<void> =>
    sendEvent(payload('listFreeOnAu', count.toString())),
};
